import { QuestionTypes } from 'interface';

export const getQuestionBadge = (id: QuestionTypes) => {
    switch (id) {
        case QuestionTypes.simple:
            return questionBadges.text;
        case QuestionTypes.number:
            return questionBadges.number;
        case QuestionTypes.email:
            return questionBadges.email;
        case QuestionTypes.website:
            return questionBadges.website;
        case QuestionTypes.camera:
            return questionBadges.camera;
        case QuestionTypes.date:
            return questionBadges.date;
        case QuestionTypes.mobileNumber:
            return questionBadges.mobile;
        case QuestionTypes.phoneNumber:
            return questionBadges.phone;
        case QuestionTypes.dropDown:
            return questionBadges.dropdown;
        case QuestionTypes.pictureSelective:
            return questionBadges.pictureSelective;
        case QuestionTypes.twoOptions:
            return questionBadges.twoOption;
        case QuestionTypes.selective:
            return questionBadges.selective;
        case QuestionTypes.nps:
            return questionBadges.nps;
        case QuestionTypes.rate:
            return questionBadges.rate;
        case QuestionTypes.scale:
            return questionBadges.scale;
        default:
            return questionBadges.text;
    }
};

export const questionBadges = {
    email: {
        icon: 'email',
        color: '#01a9ac',
    },
    text: {
        icon: 'menu',
        color: '#ff7c7c',
    },
    website: {
        icon: 'link',
        color: '#9575cd',
    },
    mobile: {
        icon: 'phone_iphone',
        color: '#23b7e5',
    },
    phone: {
        icon: 'call',
        color: '#f4c32f',
    },
    number: {
        icon: 'apps',
        color: '#3cecc0',
    },
    twoOption: {
        icon: 'check_box',
        color: '#d25284',
    },
    radio: {
        icon: 'radio_button_checked',
        color: '#816a22',
    },
    picOption: {
        icon: 'collections',
        color: '#0c905d',
    },
    rate: {
        icon: 'grade',
        color: '#ed553b',
    },
    camera: {
        icon: 'camera_alt',
        color: '#9575cd',
    },
    date: {
        icon: 'today',
        color: '#4c8031',
    },
    dropdown: {
        icon: 'format_list_numbered_rtl',
        color: '#1c40d2',
    },
    selective: {
        icon: 'library_add_check',
        color: '#579728',
    },
    pictureSelective: {
        icon: 'collections',
        color: '#bab500',
    },
    nps: {
        icon: 'looks_6',
        color: '#77534a',
    },
    scale: {
        icon: 'linear_scale',
        color: '#01a9ac',
    },
};
